import * as React from 'react';

import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import { PreparationOrderDTO, Res, Permission } from 'core/api';
import { BackActionButton, Content, Footer, Header, PhoneOnly, PosScreen } from 'pos/ui';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { RestaurantFacade } from 'pos/facades';
import { Modal } from 'core/ui-next/modal';
import { VStack, Box, Text } from '@chakra-ui/react';
import { CustomList, SvgIcon } from 'core/ui-next';
import * as Images from 'pos/Images';

type Props = {
	preparationOrders: PreparationOrderDTO[],
	selectedPreparationOrder: Nullable<PreparationOrderDTO>
} & Modal.Actions<PreparationOrderDTO>;

function ChangePreparationOrderScreen(props: Props): React.JSX.Element {
	const { cancel, close, preparationOrders, selectedPreparationOrder } = props;
	const preparationOrderId = selectedPreparationOrder ? selectedPreparationOrder.Id : 0;

	return (
		<PosScreen size={'small'} screenId={'CHANGE_PREPARATION_ORDER'}>
			<Header title={Res.Web.PREPARATION_ORDER_CLM()} onClose={cancel} />
			<Content>
				<VStack paddingX={'6'} paddingY={'9'} h='full' w='full' gap={'6'}>
					<VStack gap={'4'} justifyItems={'center'} w='full'>
						<SvgIcon src={Images.ChangeDefaultPreparationOrder} w={'12'} h={'12'} />
						<Text fontSize={'md'} fontWeight={'semibold'}>
							{Res.Web.SELECT_PREPARATION_ORDER_LBL()}
						</Text>
					</VStack>
					<Box w='full' overflowY={'auto'}>
						<CustomList
							items={preparationOrders}
							itemKey={order => order.Id}
							itemText={order => order.Name}
							onSelectItem={(order) => close(order)}
							selectedItemKey={preparationOrderId}
						/>
					</Box>
				</VStack>
			</Content>
			<Footer>
				<PhoneOnly>
					<BackActionButton action={async () => { cancel(); }} />
				</PhoneOnly>
			</Footer>
		</PosScreen>
	);
}

declare global {
	interface CommandType {
		changePreparationOrder: () => Promise<Result>
	}
}

Command.register('changePreparationOrder', Preconditions.ensure(Permission.Ticket_SetTicketLinePreparationOrder), async (): Promise<Result> => {

	const preparationOrder = SalesStore.getPreparationOrder();
	const preparationOrders: PreparationOrderDTO[] = [{ Id: 0, Name: Res.Web.CHANGE_DEFAULT_PREPARATION_ORDER_USE_PRODUCT_ORDER_LBL(), Priority: 0 }];
	preparationOrders.push(...await RestaurantFacade.getPreparationOrders());

	const selectedPreparationOrderResult = await Modal.show(ChangePreparationOrderScreen, { preparationOrders: preparationOrders, selectedPreparationOrder: preparationOrder });

	if (!selectedPreparationOrderResult.ok)
		return Result.error();

	const selectedPreparationOrderValue = selectedPreparationOrderResult.value;

	if (selectedPreparationOrderValue.Id === 0)
		await SalesStore.applyDefaultProductPreparationOrder();
	else
		await SalesStore.usePreparationOrder(selectedPreparationOrderValue);

	return Result.ok();
});
